import { render, staticRenderFns } from "./card-receiver.vue?vue&type=template&id=dc75dc46&"
import script from "./card-receiver.vue?vue&type=script&lang=js&"
export * from "./card-receiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports